import { fromJS } from 'immutable';

const getKeyPathLoop = (item, keyToFind, valToFind, childKey, onFind, currentPath = fromJS([])) =>
  item.findEntry((value, key) => {
    if (value.get(keyToFind) === valToFind) {
      onFind(currentPath.push(key));
      return true;
    } else if (value.get(childKey) && value.get(childKey).count() > 0) {
      for (let i = 0; i < value.get(childKey).count(); i += 1) {
        if (getKeyPathLoop(
            value.get(childKey),
            keyToFind,
            valToFind,
            childKey,
            onFind,
            currentPath.push(key).push(childKey)
          )) {
          return true;
        }
      }
    }
    return false;
  });

/**
 * Returns the path of the found key/value pair as an array.
 * Used to search for specific category/lightboxes in the data hierarchy.
 * @param data
 * @param keyToFind
 * @param valToFind
 * @param childKey The key that holds the children items (the value of which should be an array)
 * @returns {Array,undefined}
 */
export const getKeyPath = (data, keyToFind, valToFind, childKey) => {
  let foundPath;
  getKeyPathLoop(data, keyToFind, valToFind, childKey, (path) => {
    foundPath = path;
  });

  return foundPath ? foundPath.toJS() : undefined;
};

export const getCatDataByID = (categoryList, catID) => {
  const keyPath = getKeyPath(categoryList, 'i', catID, 'ct');

  if (keyPath) {
    return categoryList.getIn([...keyPath]);
  }
  return null;
};

export default null;



// WEBPACK FOOTER //
// ./src/js/utils/immutableUtils.js